module.exports = __webpack_public_path__ + "img/55_28.11461973.png";